import {PlatformService} from './../../services/platform.service';
import {Injectable} from "@angular/core";
import {PopupMessage, PopupMessageType} from "@app/presentation/components/errors/popup.message";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {SnackBar} from "@app/presentation/components/snack-bar/snack-bar";
import {Dialog} from "@app2u/dialogs";
import {ErrorModalService} from "@app/presentation/services/error-modal/error-modal.service";
import {NavigationAction} from "@app/core/shared/domain/entities/navigation-action";
import {NavigationActionToRouteMapper} from "@app/presentation/utils/navigation-action-to-route.mapper";
import {LocalizedRouter} from "@app/presentation/services/localized-router";

@Injectable({
    providedIn: 'root',
    deps: [ErrorModalService],
})

export class PopupDispatcher {

    constructor(
        private snackBar: SnackBar,
        private errorModalService:ErrorModalService,
        private platformService: PlatformService,
        private navigationActionToRouteMapper: NavigationActionToRouteMapper,
        private localizedRouter: LocalizedRouter,
    ) { }

    setNotifier(notifier: PopupNotifier) {
        notifier.messageObservable.subscribe({
            next: errorMessage => {
            switch (errorMessage.constructor) {
                case PopupMessage:
                    this.showMessage(errorMessage as PopupMessage);
                    break;
                case NavigationAction:
                    this.navigate(errorMessage as NavigationAction);
                    break;
            }
        }})
    }

    public showMessage(message: PopupMessage) {
        if (this.platformService.isServer) {
            return;
        }
        switch (message.type) {
            case PopupMessageType.ErrorAlert:
                this.showErrorDialog(message.message)
                break
            case PopupMessageType.SnackBar:
                this.showSnackBarMessage(message.message)
                break
            case PopupMessageType.SucceedAlert:
                this.showSucceedDialog(message.message)
                break
        }
    }

    private navigate(navigationAction: NavigationAction) {
        const route = this.navigationActionToRouteMapper.map(navigationAction);
        if (route == null) {
            return;
        }
        this.localizedRouter.navigateByUrl(route.toString());
    }

    private showErrorDialog(message: string) {
        this.errorModalService.display(message);
    }

    private showSucceedDialog(message: string) {
        Dialog.showSuccessDialog(message)
    }

    private showSnackBarMessage(message: string) {
        this.snackBar.open(message)
    }
}
